export enum Rights {
    READ = 0,
    STREAM = 1,
    DOWNLOAD = 2,
    SELL = 3
}
